import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { MessageSquare, Phone } from "lucide-react";
import { SITE } from "@/lib/site";
import { isOverlayRoute, SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { VisitorTracker } from "@/components/visitor/VisitorTracker";

const FULLSCREEN = ["/search"];

const MobileCallBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-neutral-200 bg-white/95 p-3 backdrop-blur lg:hidden" data-testid="mobile-call-bar">
    <a href={SITE.phoneMainHref} data-testid="mobile-call-button" className="flex items-center justify-center gap-2 rounded-full bg-ink py-3 text-[15px] font-medium text-white">
      <Phone className="h-4 w-4" /> Call us
    </a>
    <Link to="/contact" data-testid="mobile-message-button" className="flex items-center justify-center gap-2 rounded-full border border-ink py-3 text-[15px] font-medium text-ink">
      <MessageSquare className="h-4 w-4" /> Message
    </Link>
  </div>
);

export default function Layout() {
  const { pathname, hash } = useLocation();
  const overlay = isOverlayRoute(pathname);
  const fullscreen = FULLSCREEN.includes(pathname);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-white text-ink">
      <VisitorTracker />
      <SiteHeader />
      <main className={overlay ? "" : "pt-16"}>
        <Outlet />
      </main>
      {!fullscreen && <SiteFooter />}
      {!fullscreen && <MobileCallBar />}
    </div>
  );
}
